<script setup lang="ts">
import type { Component } from "vue";

defineProps<{
  headingId: string;
  title: string;
  icon: Component;
  detail?: string;
}>();
</script>

<template>
  <div class="forecast-section-heading flex items-center justify-between gap-4">
    <h2
      :id="headingId"
      class="flex items-center gap-2.5 font-sans text-[length:var(--type-title)] leading-[1.3] font-semibold tracking-[-0.025em] text-text-primary [&>svg]:size-[21px] [&>svg]:flex-none [&>svg]:stroke-[1.75] [&>svg]:text-text-muted"
    >
      <component :is="icon" aria-hidden="true" />{{ title }}
    </h2>
    <span
      v-if="detail"
      class="text-[length:var(--type-label)] leading-normal text-text-muted max-md:hidden"
    >
      {{ detail }}
    </span>
  </div>
</template>
